module.exports = __webpack_public_path__ + "img/devices.f89e8274.png";